import { connect } from "react-redux";
import { getCategoryDetails } from "../../state/modules/category";

import CategoryHeader from "./CategoryHeader";

const mapStateToProps = state => ({
  category: getCategoryDetails(state)
});

export default connect(mapStateToProps)(CategoryHeader);
